import React, { FC, Fragment } from 'react'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material'
import { makeStyles } from '@mui/styles'

type OptionValue = string | number
type variant = 'filled' | 'outlined' | 'standard'

interface Option<T extends OptionValue> {
  value: T
  name: string | number
}

interface SelectorProps<T extends OptionValue> {
  item: Option<T>[] | undefined
  defaultLabel?: string
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement> | undefined | any
  ) => void
  value?: string | number
  id?: string
  name?: string
  labelId?: string
  label?: string
  fullWidth?: boolean
  variant?: variant
  disabled?: boolean
  size?: 'small' | 'medium'
}

const useStyles = makeStyles(() => ({
  menuPaper: {
    maxHeight: '15em'
  }
}))

export const Selector: FC<SelectorProps<OptionValue>> = ({
  onChange,
  value,
  id,
  name,
  labelId,
  item,
  defaultLabel,
  label,
  fullWidth,
  variant = 'standard',
  disabled = false,
  size
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <FormControl
        fullWidth={fullWidth}
        variant={'outlined'}
        style={{ width: '100%' }}
        disabled={disabled}
        size={size}
      >
        <InputLabel id={labelId} style={{ paddingTop: size === 'small' ? '0px' : '8px' }}>
          {label}
        </InputLabel>
        <Select
          onChange={onChange}
          value={!value ? '-1' : value}
          id={id}
          name={name}
          labelId={labelId}
          fullWidth={fullWidth}
          style={{ width: '100%' }}
          label={label}
          MenuProps={{ classes: { paper: classes.menuPaper } }}
          variant={variant}
          size={size}
        >
          {/* Renderiza la opción de "Seleccione" solo si `defaultLabel` está definido */}
          {defaultLabel && (
            <MenuItem
              key={-1}
              value='-1'
            >{`Seleccione ${defaultLabel}`}</MenuItem>
          )}
          {item !== undefined &&
            item.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Fragment>
  )
}
